import { CreditCardService } from '../../../../services/credit-card.service'
import { isRequestCanceled } from '../../../../services/axios.service'

/**
 * @return {Promise<Array|null>} the options, or `null` when a newer call superseded this one
 * (keep latest) - the caller must keep what it has instead of treating it as "no installments"
 */
export async function getCreditCardInstallmentOptions(value) {
	let options = []
	if (value === 0) return options

	let response
	try {
		response = await CreditCardService.GetInstallmentsOptions(value)
	} catch (error) {
		if (isRequestCanceled(error)) return null
		throw error
	}
	const array = response.data

	if (array.length > 0) {
		array.forEach((element, index) => {
			let interest = element.installments * element.installmentValue - value
			let installmentValue = element.installmentValue.$toReais()
			let label =
				index == 0
					? `${installmentValue} à vista`
					: `${element.installments}x de
						${installmentValue} ${
							element.withInterest
								? '(Juros: ' + interest.$toReais() + ')'
								: ' sem juros'
					  }
						 `

			options.push({
				value: element.installments,
				label: label,
				interest,
			})
		})
	}
	return options
}
